module.exports = __webpack_public_path__ + "img/iriomote_15.25b07fbc.jpg";